import { useTranslation } from "react-i18next";
import styled from "styled-components";

type Props = {
    displayName: string;
};

export default function NoVoteAllowedMessage({ displayName }: Props) {
    const { t } = useTranslation();

    return (
        <NoVoteAllowed data-testid={`voter-${displayName}`}>
            {t("noAllowedToVote")}
        </NoVoteAllowed>
    );
}

const NoVoteAllowed = styled.p`
    color: #f62323;
    font-weight: 600;
    margin-top: 10px;
`;
